import {useSuspenseQueries} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {parseDateWithFormat} from '@shared/dateUtils';

const RECENT_HISTORY_DISPLAY_LIMIT = 10;

function useMileageBalance(vin: string) {
  const [{data: infoMileageData}, {data: memberPointData}] = useSuspenseQueries({
    queries: [
      {
        queryKey: [getQueryKey(diApi.ecoMileageController.getInfoMileage), vin],
        queryFn: () => diApi.ecoMileageController.getInfoMileage({vin}),
      },
      {
        queryKey: [getQueryKey(diApi.ecoMileageController.getMemberPointInfo)],
        queryFn: () => diApi.ecoMileageController.getMemberPointInfo({vin}),
      },
    ],
  });
  const mileageHistory = infoMileageData.data.rtn_data.PYMNT_INFO.map((data) => ({
    ...data,
    pynmt_incntv_de: parseDateWithFormat(data.pynmt_incntv_de),
  }));
  const {total_remain_point: totalRemainPoint} = memberPointData.data.rtn_data;
  const totalAccumulatedPoint = mileageHistory.reduce((acc, cur) => acc + cur.pynmt_incntv, 0);
  const latestMileageHistory = mileageHistory.slice(-RECENT_HISTORY_DISPLAY_LIMIT);
  return {
    totalRemainPoint,
    totalAccumulatedPoint,
    latestMileageHistory,
  };
}

export default useMileageBalance;
